module.exports = __webpack_public_path__ + "assets/d96b42f362c8be64a3dffed8d15f0762.mp3";